module.exports = __webpack_public_path__ + "components/rewards/skiset/static/logo-9dd6044f50bfcc1ccd595dafdebdc37f.webp";